import React from 'react';
import InputMask from '../InputMask';

const InputHhMm = (props) => {
  const getMask = (rawValue) => {
    const separator = ':';
    const digits = rawValue.replace(/\D/g, '');
    if (digits.length <= 3) {
      return [/\d/, separator, /\d/, /\d/];
    }
    const minutes = [...digits.slice(-2)].map(() => /\d/);
    const hours = [...digits.substring(0, digits.length - 2)].map(() => /\d/);
    return [...hours, separator, ...minutes];
  };
  return <InputMask {...props} mask={getMask} />;
};

export default InputHhMm;
